



























































































































































import {
  Component,
  Prop,
  Vue,
  Mixins,
  ProvideReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { specialChannel } from "@root/lib/mixins";
import spuTab from "@/components/pages/ProductCreate/spuTab.vue";
import skuTab from "@/components/pages/ProductCreate/skuTab.vue";
import channelSpuTab from "@/components/pages/ProductCreate/channelSpuTab.vue";
import channelSkuTab from "@/components/pages/ProductCreate/channelSkuTab.vue";
import extendCascader from "@/components/pages/ProductCreate/extendCascader.vue";
import selectChannelCategory from "@/components/pages/ProductCreate/selectChannelCategory.vue";
import { prompt } from "@root/lib/utils";

const productCreate = namespace("productCreate");
const product = namespace("product");
@Component({
  components: {
    spuTab,
    skuTab,
    extendCascader,
    selectChannelCategory,
    channelSpuTab,
    channelSkuTab
  }
})
export default class ProductCreate extends Mixins(specialChannel) {
  @ProvideReactive("curChannel") curChannel: any = {
    label: "Master",
    value: "master"
  };
  @ProvideReactive("curCategory") curCategory: any = [];
  @ProvideReactive("curBrandId") curBrandId: any = [];
  active: string = "spu";
  productCode: string | (string | null)[] = "";
  loading: boolean = true;
  saveSkuSuccess = false;
  productChannelList = [];
  channelProductInfo = "";
  defaultOrg = localStorage.getItem("org");
  tabKey = new Date().getTime();
  hasCategory = false;
  categoryAttrObj: any = {};
  responseStr = "[AL]";
  isViewMode = false;
  get publishChannelList() {
    return [
      // {
      //   text: this.$t("20200917.Product.publish_product"),
      //   value: 0
      // },
      // {
      //   text: this.$t("20200917.Product.publish_product_sku"),
      //   value: 1
      // }
    ];
  }
  @productCreate.Action queryProductInfo: any;
  @productCreate.Action querySkuAttrData: any;
  @productCreate.Action updateProduct;
  @productCreate.Getter propertiesData;
  @productCreate.Action batchEditSku;
  @productCreate.Action queryConnAttrList;
  @productCreate.Action queryProductChannelList;
  @productCreate.Action saveConnProduct;
  @productCreate.Action saveConnSkuList;
  @productCreate.Action getProductChannel;
  @productCreate.Action publishProduct;
  @product.Action batchUpdateSkuPrice;
  @productCreate.Getter originProductPrice;
  get selectChannelShopText() {
    let { curChannel } = this;
    let result =
      curChannel.value === "master"
        ? curChannel.label
        : curChannel.channelCode + " - " + curChannel.shopName;
    return result;
  }
  get isEditChannel() {
    return this.curChannel.value !== "master";
  }
  async mounted() {
    this.productCode = this.$route.query.productCode;
    this.isViewMode = !!this.$route.query.isViewMode;
    let res = await this.queryProductInfo(this.productCode);
    this.loading = false;
    await this.getChannelList();
  }
  async getChannelList() {
    let saveChannelList = await this.queryProductChannelList({
      productCode: this.productCode
    });
    this.productChannelList = [
      { label: "Master", value: "master" },
      ...saveChannelList
    ];
  }

  async handleSaveProduct() {
    if (this.isEditChannel) {
      await this.saveChannelProduct();
    } else {
      await this.saveProduct();
    }
  }
  // 获取已保存的渠道信息
  async getChannelProduct(channel) {
    let saveRes = await this.getProductChannel({
      productCode: this.propertiesData.productCode,
      shopCode: channel.value
    });
    this.channelProductInfo = saveRes;

    this.curCategory = [];
    this.curBrandId = "";
    if (saveRes && saveRes.extendParams) {
      // PrimaryCategory 分类存到这个分类
      let obj = JSON.parse(saveRes.extendParams);
      if (obj.categoryPath) {
        let arr = obj.categoryPath[this.responseStr][0].split(">");
        if (arr.length > 0) {
          this.curCategory = arr;
        }
      }
      // prop_20000 是赵老师给的品牌key
      if (this.isTmall(channel.channelCode) && obj.prop_20000) {
        this.curBrandId = obj.prop_20000[this.responseStr][0];
      }
    }
  }
  async onlySavechannelProduct() {
    let res = await (this.$refs.channelSpuTab as any).submit();
    console.log(res, "664433");

    let result = [];
    res.forEach(item => {
      result = [...result, ...item];
    });
    result.push({
      channelAttrCode: this.categoryAttrObj.channelAttrCode,
      attrValueList: [
        {
          channelAttrValue: this.curCategory[this.curCategory.length - 1]
        }
      ]
    });

    result.push({
      channelAttrCode: "categoryPath",
      attrValueList: [
        {
          channelAttrValue: this.curCategory.join(">")
        }
      ]
    });
    let input = {
      productCode: this.propertiesData.productCode,
      shopCode: this.curChannel.value,
      // shopCode: "10000151",
      channelAttrValue: result
    };
    await this.saveConnProduct({ input });
  }
  async saveChannelProduct() {
    await this.onlySavechannelProduct();
    let message: any = this.$t("Basic.success");
    this["$message"].success(message);
    this.tabKey = new Date().getTime();
    await this.getChannelList();
    this.curChannel.isEdit = false;
    // this.getChannelProduct();
  }
  // 保存master 商品信息
  async saveProduct() {
    let res = await (this.$refs.spuTab as any).submit();

    let localeList = [];
    let result: any = {};
    res.forEach(item => {
      if (item.localeList) {
        localeList = [...localeList, ...item.localeList];
        delete item.localeList;
      }
      result = { ...result, ...item };
    });
    result = {
      ...result,
      localeList
    };
    await this.updateProduct(result);
    let message: any = this.$t("Basic.success");
    this["$message"].success(message);
    // 提示是否同步商品价格到SKU 价格
    if (
      this.originProductPrice.productPrice != result.productPrice ||
      this.originProductPrice.salePrice != result.salePrice
    ) {
      this.asynchronousPriceToSKU();
    }
    await this.queryProductInfo(this.propertiesData.productCode);
  }
  async handleSaveSKU() {
    if (this.isEditChannel) {
      // await this.saveChannelSKU();
    } else {
      await this.saveSKU();
    }
  }
  async saveSKU() {
    let res = await (this.$refs.skuTab as any).submit();
    let sku = res[0];
    await this.batchEditSku(sku.skuList);
    let message: any = this.$t("Basic.success");
    this["$message"].success(message);
    this.saveSkuSuccess = true;
  }
  cancelProduct() {
    this.$router.push({ name: "Product" });
  }
  handleCopy() {
    let message: any = this.$t("20200813.Product.copy_success");
    this["$message"].success(message);
  }
  async skuChangeProductStatus() {
    await this.queryProductInfo(this.propertiesData.productCode);
    this.saveSkuSuccess = false;
  }
  addChannelFn() {
    (this as any).$refs.selectChannelCategory.visible = true;
  }
  async addChannelConfirm({ value, label }) {
    let { channel, category, brandCode } = value;
    console.log(value, 855);

    let { channel: channelLabel } = label;
    this.curCategory = category;
    this.curChannel = {
      value: channel[1],
      channelCode: channel[0],
      shopName: channelLabel.split("/")[1],
      isEdit: true
    };
    if (brandCode) {
      this.curBrandId = brandCode;
    }
    this.productChannelList.push(this.curChannel);
    this.tabKey = new Date().getTime();
  }
  async handleChangeChannel(channel) {
    // this.curChannel = channel;
    // this.tabKey = new Date().getTime();
    if (channel.value === this.curChannel.value) {
      return;
    }
    if (channel.value !== "master") {
      //1.请求已保存数据，拿到分类
      //2.根据分类查询属性结构列表
      await this.getChannelProduct(channel);
      this.curChannel = channel;
      this.tabKey = new Date().getTime();
    } else {
      this.curChannel = channel;
      this.tabKey = new Date().getTime();
      let res = await this.queryProductInfo(this.productCode);
      this.loading = false;
    }
  }
  switchCategory(data) {
    this.curCategory = data;
    this.tabKey = new Date().getTime();
  }
  switchBrand(data) {
    this.curBrandId = data;
    this.tabKey = new Date().getTime();
  }
  savechannelSkuSuccess() {
    this.tabKey = new Date().getTime();
  }
  getSavedCategory(data) {
    this.curCategory = data;
  }
  async handlePublishChannel(value) {
    let info: any = this.$t("20200917.Product.save_publish_notice");
    let confirmButtonText: any = this.$t("20200917.Product.publish");
    this.$confirm(info, {
      confirmButtonText,
      type: "warning"
    })
      .then(async () => {
        // 先保存
        await this.onlySavechannelProduct();
        // 再发布
        let res = await this.publishProduct({
          input: {
            codeList: [this.productCode],
            shopCode: this.curChannel.value
          }
        });
        this.tabKey = new Date().getTime();
        await this.getChannelList();
        this.curChannel.isEdit = false;
        // let message: any = this.$t("Product.publish_submited");
        // this["$message"].success(message);
        this.publishSuccess();
      })
      .catch(() => {
        // this.visible = false;
      });
  }
  getCategoryAttr(data) {
    this.categoryAttrObj = data;
  }
  asynchronousPriceToSKU() {
    prompt
      .call(this, {
        message: this.$t("Product.synchronous_price"),
        confirmButtonText: this.$t("Basic.ok")
      })
      .then(async () => {
        await this.batchUpdateSkuPrice({
          productCode: this.propertiesData.productCode
        });
        let message: any = this.$t("Basic.success");
        this["$message"].success(message);
        this.queryProductInfo(this.propertiesData.productCode);
      })
      .catch(error => {
        console.log(error);
      });
  }
  publishNotice = null;
  publishSuccess() {
    (window as any).handleViewPublish = this.handleViewPublish.bind(this);
    this.publishNotice = this.$message({
      type: "success",
      showClose: true,
      dangerouslyUseHTMLString: true,
      customClass: "pim-message-wrap",
      message: `<div class="pim-product-success">    
          <p>${this.$t("Product.publish_submited")}</p>
          <p class="pim-product-view" onclick="handleViewPublish()">${this.$t(
            "Product.view_result"
          )}</p></div>`
    });
  }
  handleViewPublish() {
    this.publishNotice && this.publishNotice.close();
    this.$router.push({
      name: "Publish",
      params: { channel: this.curChannel.channelCode },
      query: { name: this.curChannel.channelCode }
    });
  }
}
